import { render, staticRenderFns } from "./StageConsignmentStarted.vue?vue&type=template&id=8972b73e&scoped=true&"
import script from "./StageConsignmentStarted.vue?vue&type=script&lang=ts&"
export * from "./StageConsignmentStarted.vue?vue&type=script&lang=ts&"
import style0 from "./StageConsignmentStarted.vue?vue&type=style&index=0&id=8972b73e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8972b73e",
  null
  
)

export default component.exports